import { render, staticRenderFns } from "./AchievementNel.vue?vue&type=template&id=16c0cdc4&scoped=true&"
import script from "./AchievementNel.vue?vue&type=script&lang=js&"
export * from "./AchievementNel.vue?vue&type=script&lang=js&"
import style0 from "./AchievementNel.vue?vue&type=style&index=0&id=16c0cdc4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c0cdc4",
  null
  
)

export default component.exports